<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="dialogRefuse split-line-footer-dialog"
    :width="type === 'agree'?'400px':'520px'"
    :before-close="cancel"
  >
    <!-- 标题 -->
    <div slot="title" class="text-medium-x">
      <!-- 修改审核才有icon -->
      <i v-if="editAudit" class="el-icon-warning mr-2" style="color: orange;"></i>
      <span>{{ title }}</span>
    </div>
    <!-- ======提示部分===== -->
    <!-- 一键通过、一键拒绝的提示 -->
    <div v-if="title.includes('一键')" class="leading-20">
      本次抽取，全部未审答卷共<span  class="text-danger text-medium-x font-bold">{{ eligibleTotal }}</span>份，
      确认全部{{ type==='refuse'?'拒绝':'通过' }}审核吗？
      <span style="color: #aaa">（{{ type==='refuse'?'拒绝':'通过' }}后不能撤销）</span>
    </div>
    <!-- 修改审核的提示 -->
    <div v-else-if="editAudit && type==='agree'" class="leading-22 edit-audit">
      答卷当前审核结果为“质控拒绝”，请输入“<span class="text-danger">质控通过</span>”，将审核结果变更为质控通过
    </div>
    <!-- 普通通过的提示 -->
    <div v-else v-show="type==='agree'">确认通过后将不能撤销。</div>

    <!-- ======原因部分===== -->
    <!-- 通过 - 输入原因 -->
    <div v-if="type === 'agree'" class="singleBtn">
      <label class="block my-2">说明：</label>
      <el-input v-model="desc" :maxlength="200"></el-input>
    </div>
    <!-- 拒绝、驳回 - 选择原因 -->
    <div v-else>
      <el-checkbox-group v-model="refuseType">
        <el-checkbox class="block" v-for="item in refuseTypeList" :key="item.code" :label="item.code">{{item.label}}</el-checkbox>
      </el-checkbox-group>
      <!-- 107为‘其他’的code -->
      <textarea :maxlength="200" v-if="refuseType.includes(OTHER)" placeholder="请输入" v-model="textareaOther"> </textarea>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel" class="text-theme-black-450 border-theme-black-450 normal-button">取 消</el-button>
      <el-button size="small" type="primary" @click="confirm" class="normal-button" :loading="confirmLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCause } from '@/api/wenjuan/multiAudit'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'agree'
    },
    title: {
      type: String,
      default: '审核拒绝'
    },
    eligibleTotal: {
      type: Number,
      default: 0
    },
    editAudit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      refuseType: [],
      textareaOther: '',
      desc: '',
      refuseTypeList: [],
      refuseTypeMap: new Map(),
      OTHER: '107'
    }
  },
  mounted() {
    this.getCause()
  },
  methods: {
    confirm() {
      //编辑审核（通过） 的校验
      if(this.editAudit && this.type === 'agree' && this.desc !== '质控通过') {
        this.$message.error('输入描述不合规，请重新输入')
        return
      }
      //不是“通过”类型的审核 - 校验
      if( this.type !== 'agree' ) {
        if (!this.refuseType.length) {
          this.$message.warning('至少勾选一个拒绝原因')
          return
        }
        if (this.refuseType.includes(this.OTHER) && !this.textareaOther) {
          this.$message.warning('请输入拒绝原因')
          return
        }
      }
      let data
      if( this.type !== 'agree') {
        data = this.refuseType.map(code => ({
          id: code,
          cause: code!== this.OTHER ? this.refuseTypeMap.get(code) : this.textareaOther
        }))
      }else {
        data = this.desc
      }
      this.$emit('update:confirmLoading', true)
      this.$emit('confirm', data)
    },
    cancel() {
     this.clear()
      this.$emit('update:visible', false)
    },
    clear() {
      this.refuseType = []
      this.textareaOther = ''
      this.desc = ''
    },
    getCause() {
      getCause().then(res => {
        if(res.data.code !== 0) {
          this.$message.error(res.data.msg)
          return
        }
        const {data: {data}} = res
        this.refuseTypeList = Object.keys(data).map(code => ({
          label: data[code],
          code
        }))
        this.refuseTypeMap = new Map( Object.keys(data).map(code => {
          return [code, data[code]]
        }))
      })
    }
  },
  watch: {
    visible(n) {
      if(n) {
        this.clear()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 审批拒绝弹窗
.dialogRefuse {
  .el-dialog__header {
    height: 48px;
    background: #f5f7fa;
    border-radius: 4px 4px 0 0;
    padding: 0 16px;
  }
  .el-dialog__body {
    @apply p-0 pt-4 pl-4;
    .el-checkbox {
      @apply mb-2 text-theme-black-850 font-normal text-medium leading-22;
      .el-checkbox__inner {
        @apply mr-1;
      }
    }
    textarea {
      @apply bg-eee  rounded-small font-normal text-medium leading-22 border-none ml-6;
      width: 436px;
      height: 78px;
      padding: 5px 14px;
      resize: none;
    }
    textarea:focus {
      background: #f2f5fa;
    }
  }
  .el-dialog__footer {
    @apply p-0 pr-4 pb-4;
  }
}

// 禁止选中
.edit-audit {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none
}
</style>